export default __webpack_public_path__ + "static/media/headgear.6d1a0b2e.svg";